const routes = [
  {
    path: '/',
    name: 'sayl-oat-catalog.catalog',
    component: () => import('./catalog'),
    meta: {
      bodyClass: 'view-catalog-list'
    },
    children: [
      {
        path: '/product/:product',
        name: 'sayl-oat-catalog.product',
        component: () => import('./product'),
        meta: {
          bodyClass: '-no-scroll'
        }
      }
    ]
  }
]


export default routes;
